import { render, staticRenderFns } from "./SilagemDadosVisita.vue?vue&type=template&id=d08ba498&"
import script from "./SilagemDadosVisita.vue?vue&type=script&lang=js&"
export * from "./SilagemDadosVisita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports